import React from 'react';
import { useLocation } from 'react-router-dom';
import TopBarContent from './AppTopBar/TopBarContent';

const Header = () => {
  const { pathname, search } = useLocation();
  return <TopBarContent isDashboardHeader pathname={pathname + search} />;
};

export default Header;
